const e=3,l=1e3,o="level1";export{l as ALGOLIA_CATEGORY_TREE_FINDER_HITS_LIMIT,o as CATEGORIES_ROOT_LEVEL,e as DEFAULT_MIN_REQUESTED_INPUT_LENGTH};
